import type { ReactEventHandler } from 'react';

import type { BaseComponentProps } from '../../types';
import type { StickerProps } from '../Sticker/Sticker';

export interface VideoProps extends BaseComponentProps {
  source: string;
  mobileSource?: string;
  sourceType?: string;
  mobileSourceType?: string;
  posterSource?: string;
  altText?: string;
  muted?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  controls?: boolean;
  playsInline?: boolean;
  onPlay?: ReactEventHandler<HTMLVideoElement>;
  captionsSource?: string;
  isBackgroundVideo?: boolean;
  onTimeUpdate?: ReactEventHandler<HTMLVideoElement>;
}

export interface VideoWithStickersProps extends VideoProps {
  videoClassName?: string;
  stickers?: StickerProps[];
}
